import React from 'react';
import styled from 'styled-components';
import { NoCompanies } from 'Components/common/assets/svgIcons/NoCompanies';
import GlobalButton from 'Components/common/components/GlobalButton';
import { primaryFont, wMedium, primaryHeadingColor, SecondaryColor } from '../../../Utils/utilsStyle';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const IconWrapper = styled.div`
  margin-bottom: 24px;
`;

const Title = styled.div`
  color: ${primaryHeadingColor};
  font-family: ${primaryFont};
  font-size: 14px;
  font-weight: ${wMedium};
  line-height: normal;
  letter-spacing: -0.336px;
  margin-bottom: 6px;
`;

const Subtitle = styled.div`
  color: #67696A;
  font-family: ${primaryFont};
  font-size: 14px;
  line-height: normal;
  letter-spacing: -0.336px;
  margin-bottom: 32px;
`;

const ButtonWrapper = styled.div`
  .no-data-btn button {
    border-radius: 6px;
    background: ${SecondaryColor};
    cursor: pointer;
  }
`;

type Props = {
  title: string,
  subtitle?: string,
  btnText?: string,
  redirectTo?: () => void,
};

const NoDataMessage = ({ title, subtitle, btnText, redirectTo }: Props) => {
  return (
    <Container className='no-data-msg-container'>
      <IconWrapper>
        <NoCompanies />
      </IconWrapper>
      <Title>{title}</Title>
      <Subtitle>{subtitle}</Subtitle>
      <ButtonWrapper>
        <div className="no-data-btn">
          <GlobalButton
            title={btnText}
            onButtonClick={redirectTo}
          />
        </div>
      </ButtonWrapper>
    </Container>
  );
};

export default NoDataMessage;